<template> 
  <HomeInicio />

  <div class="container">
    <div class="barra-superior-confirmados">
  <input
    id="searchName"
    v-model="searchName"
    type="text"
    placeholder="Filtrar por nombre o nombre"
    class="input-busqueda"
  />

  <div class="conteo-totales">
    <p>Total de Confirmados: <strong>{{ totalRegistros }}</strong></p>
  </div>

  <button class="btn btn-download" @click="descargarExcel">
    <img src="@/assets/excel.png" alt="Descargar Excel" class="download-icon" />
    Descargar Excel
  </button>
</div>

    <div class="add-invitados-container">
      <h2 class="title">Invitados Confirmados</h2>
      <p class="description">A continuación se muestran los registros que confirmaron asistencia.</p>

      <div class="table-wrapper">
  <table class="table">
    <thead>
      <tr>
        <th>No.</th>
        <th>Nombre</th>
        <th>Teléfono</th>
        <th>Asistirá</th>
        <th>Número de Pases</th>
        <th>Número de Mesa</th>
        <th>Fecha</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="registrosFiltrados.length === 0">
        <td colspan="8" class="text-center">No hay datos disponibles.</td>
      </tr>
      <tr v-for="(invitado, index) in registrosFiltrados" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ invitado.nombre_asistencia || '' }}</td>
        <td>{{ invitado.telefono_invitado || '' }}</td>
        <td>{{ invitado.asistira || '' }}</td>
        <td>{{ invitado.num_pases !== undefined && invitado.num_pases !== null ? invitado.num_pases : 'N/A' }}</td>
        <td>{{ invitado.num_mesa || '' }}</td>
        <td>{{ formatDate(invitado.fecha) }}</td>
        <td>
          <button class="btn-delete" @click="confirmarEliminacion(invitado)">
            Eliminar
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</div>

  </div>
</template>
  
  <script>
  import HomeInicio from "@/components/HomeInicio.vue";
  import baseUrl from '../api';
  import * as XLSX from 'xlsx';
  import Swal from 'sweetalert2';
  import axios from 'axios';

  export default {
    name: "ConfirmadosV",
    components: {
      HomeInicio
    },
    data() {
      return {
        idFestejada: localStorage.getItem('id_festejada'),
        registros: [],
        filterAsistira: '', // Filtro por asistirá
        searchName: '', // Filtro por nombre
      };
    },
    computed: {
      // Filtro los registros según los valores de los filtros
      registrosFiltrados() {
        return this.registros.filter((invitado) => {
          const matchesAsistira = this.filterAsistira ? invitado.asistira === this.filterAsistira : true;
          const matchesName = this.searchName ? invitado.nombre_asistencia.toLowerCase().includes(this.searchName.toLowerCase()) : true;
          return matchesAsistira && matchesName;
        });
      },
  
      // Calcular el total de registros (no solo los confirmados)
      totalRegistros() {
        return this.registros.length;
      }
    },
    mounted() {
      if (!this.idFestejada) {
        console.error('ID Festejada no encontrado en localStorage.');
        return;
      }
      this.loadRegistros(); // Cargar los registros cuando el componente se monta
    },
    methods: {

      confirmarEliminacion(invitado) {
    Swal.fire({
      title: `¿Estás seguro de eliminar a "${invitado.nombre_asistencia}"?`,
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminarInvitado(invitado.id_asistencia);
      }
    });
  },

  async eliminarInvitado(id) {
  try {
    const response = await axios.post(`${baseUrl}/api2/eliminar-asistencia`, { id });

    // Validamos que fue exitoso
    if (response.status !== 200) {
      throw new Error('No se pudo eliminar');
    }

    // Quitamos del array local
    this.registros = this.registros.filter(i => i.id_asistencia !== id);

    Swal.fire('Eliminado', 'El invitado ha sido eliminado.', 'success');
  } catch (error) {
    console.error('Error al eliminar:', error);
    Swal.fire('Error', 'Hubo un problema al eliminar.', 'error');
  }
}


,

      async loadRegistros() {
        const idFestejada = this.idFestejada;
        if (!idFestejada) {
          console.error('ID Festejada no encontrado en localStorage.');
          return;
        }
        try {
          const response = await fetch(`${baseUrl}/api2/asistencia?id_festejada=${idFestejada}`);
          if (!response.ok) {
            throw new Error('Error en la respuesta de la API');
          }
  
          const data = await response.json();
          if (Array.isArray(data)) {
            this.registros = data;
          } else {
            console.warn('La respuesta no es un array:', data);
          }
        } catch (error) {
          console.error('Error al cargar los registros:', error);
        }
      },
  
      formatDate(dateString) {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString();
      },
  
      descargarExcel() {
        // Si no hay registros, no se puede exportar
        if (this.registros.length === 0) {
          alert('No hay registros para descargar');
          return;
        }
  
        // Preparar los datos para exportar
        const datosExcel = this.registros.map((invitado, index) => ({
          No: index + 1,
          Nombre: invitado.nombre_asistencia || '',
          Teléfono: invitado.telefono_invitado || '',
          Asistirá: invitado.asistira || '',
          'Número de Pases': invitado.num_pases !== undefined && invitado.num_pases !== null ? invitado.num_pases : '',
          'Número de Mesa': invitado.num_mesa || '', // Agregar el número de mesa al archivo de Excel
          Fecha: this.formatDate(invitado.fecha)
        }));
  
        // Crear un libro de trabajo de Excel
        const ws = XLSX.utils.json_to_sheet(datosExcel); // Convertir los datos a una hoja
        const wb = XLSX.utils.book_new(); // Crear un nuevo libro
        XLSX.utils.book_append_sheet(wb, ws, 'Invitados'); // Añadir la hoja al libro
  
        // Exportar el archivo Excel
        XLSX.writeFile(wb, 'invitados.xlsx');
      }
    }
  };
  </script>
  
  
  
<style scoped>
/* 🎯 Estilos generales conservados */
.container {
  margin-top: 20px;
  padding: 0 15px;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.invitados-count,
.filter-container,
.download-btn-container,
.barra-superior-confirmados {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #5f6770;
  font-family: 'Poppins', sans-serif;
}

/* 👑 Títulos */
.invitados-count h3 {
  font-size: 22px;
  font-weight: 600;
  color: #4a3f42;
  font-family: 'Playfair Display', serif;
}

.title {
font-family: 'Playfair Display', serif;
  font-size: 32px;
  color: #4a3f42;
  font-weight: 500;

  margin-bottom: 8px;
}

.description {
  font-size: 15px;
  color: #555;
  font-family: "Poppins", sans-serif;
  margin-bottom: 20px;
}

.titulo-invitados {
  font-size: 10px !important;
  color: #5f6770;
  font-family: 'Poppins', sans-serif;
}

/* 📋 Tabla */.table-wrapper {
  width: 100%;
  overflow-x: auto; /* ⚡ Esto activa el scroll horizontal en móviles */
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  margin-top: 20px;
  table-layout: auto;
  min-width: 900px; /* ✅ mínimo realista para que se vea bien y permita scroll en móviles */
}

.table th,
.table td {
  padding: 8px;
  text-align: center;
  font-size: 12px;
  white-space: nowrap; /* 👈 evita que el texto se rompa feo */
  overflow: hidden;
  text-overflow: ellipsis;
}

.table th {
  background-color: #5f6770;
  color: white;
}

/* 👇 En responsive */
@media (max-width: 768px) {
  .table-wrapper {
    overflow-x: auto;
  }

  .table {
    min-width: 750px; /* ✅ Para celular */
  }

  .table th,
  .table td {
    font-size: 12px;
    padding: 8px;
  }
}


/* 🧩 Inputs */
.table td input {
  width: 100%;
  max-width: 120px;
  box-sizing: border-box;
}

.filters input,
.filter-container select,
.filter-container input,
.input-busqueda {
  padding: 10px 14px;
  font-size: 14px;
  border-radius: 12px;
  border: 1px solid #ccc;
  min-width: 220px;
}

/* 🧾 Contadores */
.conteo-totales {
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #5f6770;
  line-height: 1.4;
  text-align: left;
}

.conteo-totales strong {
  color: #314250;
  font-weight: 700;
}

/* ✅ Botones */
.btn-download {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-download:hover {
  background-color: #45a049;
}

.download-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 50%;
}

.btn-delete {
  padding: 6px 10px;
  background-color: #d9534f;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 10px;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-delete:hover {
  background-color: #c9302c;
}

.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.add-invitados-container {
  width: 100%;
  margin: 0 auto 60px;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.06);
  text-align: center;
  overflow-x: hidden;
}

/* 📱 RESPONSIVE */
@media (max-width: 768px) {
  .invitados-count,
  .filter-container,
  .download-btn-container,
  .barra-superior-confirmados {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    gap: 12px;
  }

  .btn-download {
    justify-content: center;
    width: 100%;
  }

  .table {
    min-width: 1000px; /* permite scroll horizontal */
  }

  .table th,
  .table td {
    font-size: 12px;
    padding: 10px;
  }

  .filters input,
  .input-busqueda {
    width: 100%;
  }

  .conteo-totales {
    text-align: center;
  }
}

</style>